var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('img',{staticClass:"img-cover",attrs:{"src":_vm.coverPath}}),_c('div',{staticClass:"finish-box",domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":function($event){return _vm.showImg($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }